<template>
  <div class="calc_count">
    <div style="display: inline-flex; column-gap: 5px; align-items: center">
      <div
        v-if="show"
        style="display: inline-flex; column-gap: 5px; align-items: center"
      >
        <h3>Тариф:</h3>
        <router-link to="/payment" class="accents"
          >{{ calcCount.tariff }},</router-link
        >
      </div>
      <div
        v-if="show"
        style="display: inline-flex; column-gap: 5px; align-items: center"
      >
        <h3>Оставшиеся расчёты:</h3>
        <router-link to="/payment" class="accents"
          >{{ calcCount.count }},</router-link
        >
      </div>
      <div style="display: inline-flex; column-gap: 5px; align-items: center">
        <h3>Действие пакета:</h3>
        <router-link to="/payment" class="accents"
          >по
          {{ moment(calcCount.to_date).format("DD.MM.YYYY") }} г.</router-link
        >
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { roleObj } from "@/plugins/roles";

export default {
  name: "calc_count",
  components: {},
  data: () => ({
    moment,
  }),
  methods: {
    async getBackCount() {
      await this.$store.dispatch("GET_CALC_COUNT");
    },
  },
  async created() {
    await this.getBackCount();
  },
  computed: {
    calcCount() {
      return this.$store.getters.getCalcCount;
    },
    show() {
      return this.role() === roleObj.bankAdmin ||
        this.role() === roleObj.agregatorAdmin
        ? false
        : true;
    },
  },
};
</script>
<style lang="sass" scoped>
.calc_count
  padding: 0 20px
.accents
  color: var(--v-primary-base)
  text-decoration: none
</style>
